import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import LanguageToggle from "@/components/LanguageToggle";
import LegalFooter from "@/components/LegalFooter";

/**
 * Light shell used for legal pages (Impressum, Datenschutz) — keeps consistent
 * branding with Landing while keeping content focus.
 */
export default function LegalShell({ title, eyebrow, children, testid }) {
  const { user } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#F9F8F6] flex flex-col" data-testid={testid}>
      <header className="border-b border-[#E5E2D9] bg-white/60 backdrop-blur sticky top-0 z-20">
        <div className="container mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
          <Logo />
          <div className="flex items-center gap-3">
            <LanguageToggle />
            {user ? (
              <Button onClick={() => nav("/app")} className="bg-[#1A2F24] hover:bg-[#2E3B32] text-white">
                {t("nav.dashboard")}
              </Button>
            ) : (
              <Link to="/login" className="text-sm text-[#1A2F24] hover:underline" data-testid="legal-link-login">
                {t("nav.login")}
              </Link>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1">
        <section className="container mx-auto px-4 md:px-8 py-12 md:py-20 max-w-3xl">
          {eyebrow && (
            <div className="text-xs uppercase tracking-[0.2em] text-[#C05A44] font-medium mb-3">
              {eyebrow}
            </div>
          )}
          <h1 className="font-display font-bold text-4xl md:text-5xl tracking-tighter text-[#1A2F24] mb-10">
            {title}
          </h1>
          <article className="prose prose-sm max-w-none text-[#1A2F24]">
            {children}
          </article>
        </section>
      </main>
      <LegalFooter />
    </div>
  );
}
